
function stickyHeader() {
    return {
      header: null,
      spacer: null,
      isSticky: false,
      headerHeight: 0,
      notCompHeight: 0,

      init() {
        this.header = this.$refs.header;
        this.spacer = this.$refs.spacer;

        if (!this.header || !this.spacer) return;

        this.updateDimensions();
        this.setSpacerHeight(0);

        let resizeTimeout;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => {
            this.updateDimensions();
            if (this.isSticky) {
              this.setSpacerHeight(this.header.offsetHeight);
            }
          }, 100);
        });

        window.addEventListener('scroll', () => this.handleScroll());
      },

      updateDimensions() {
        const notComp = document.querySelector('.not_comp');
        this.headerHeight = this.header?.offsetHeight || 0;
        this.notCompHeight = notComp?.offsetHeight || 0;
      },

      setSpacerHeight(height) {
        if (this.spacer) {
          this.spacer.style.height = `${height}px`;
        }
        // Mirrors the fixed header's real height into a CSS var so any
        // other component (e.g. a sticky sidebar) can dock right under it
        // instead of guessing/hardcoding an offset.
        document.documentElement.style.setProperty('--sticky-header-height', `${height}px`);
      },

      handleScroll() {
        if (!this.header || !this.spacer) return;

        const scrollTop = window.scrollY;

        if (scrollTop > this.notCompHeight && !this.isSticky) {
          this.header.classList.add('sticky');
          this.setSpacerHeight(this.headerHeight);
          this.isSticky = true;
        } else if (scrollTop <= this.notCompHeight && this.isSticky) {
          this.header.classList.remove('sticky');
          this.setSpacerHeight(0);
          this.isSticky = false;
        }
      }
    };
  }

